<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	export let isOpen = false;
	export let vehicleStatus = "";
	export let targetStatusLabel = "";

	const dispatch = createEventDispatcher();

	function close() {
		dispatch("close");
	}

	function confirm() {
		dispatch("confirm");
	}
</script>

<Modal {isOpen} toggle={close} centered>
	<ModalHeader toggle={close}>Change vehicle status</ModalHeader>
	<ModalBody>
		<p class="my-3 vehicle-status-text">
			{#if targetStatusLabel}
				The vehicle status is '{vehicleStatus || "-"}'. Do you want to
				set it as '{targetStatusLabel.toUpperCase()}'?
			{:else}
				The vehicle status is '{vehicleStatus || "-"}'. It can only be
				changed here between Active and Inactive - In Workshop.
			{/if}
		</p>
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton" on:click={close}>Cancel</Button>
		<Button
			class="themeButton primary"
			disabled={!targetStatusLabel}
			on:click={confirm}
		>
			Confirm
		</Button>
	</ModalFooter>
</Modal>

<style>
	.vehicle-status-text {
		font-size: 14px;
	}
</style>
